// extracted by mini-css-extract-plugin
export default {"ProcessingPageContainer":"ProcessingPage_ProcessingPageContainer__9v3z0","header":"ProcessingPage_header__Dk7y6"};